import { TranslateService } from '@ngx-translate/core';
import { ActionAuthLoginSuccess } from '@app/core';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProgressBarService } from '@app/shared/services/progress-bar.service';
import { InfoService } from '@app/core/info/info.service';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { OperationTypes } from '@app/core/auth/auth.interfaces';
import { Subject } from 'rxjs';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { takeUntil } from 'rxjs/operators';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { EmergencyService } from '@app/core/auth/component/emergency-login/emergency-login.service';
import { environment } from 'environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { configureReCaptchaWithEnv } from '../../reCaptcha-util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'emergency-login',
  templateUrl: './emergency-login.component.html',
  styleUrls: ['./emergency-login.component.scss']
})
export class EmergencyLoginComponent implements OnInit {

  emergencyForm = new FormGroup({
    emergencyRequestId: new FormControl(''),
    recaptcha: new FormControl('')
  });

  operationType: OperationTypes;
  operation = new Subject<OperationTypes>();
  operation$ = this.operation.asObservable();
  unsubscribe$: Subject<void> = new Subject<void>();

  submit: boolean;

  responseResult: string;
  secretKeyRes: string;
  uniqueToken: string;
  recaptchaResponse: string;
  personalId: string;
  captchaEnabled: boolean;
  usingLang: string;
  reCaptcha2SiteKey: string;
  invisibleCaptchaSiteKey: string;

  showNoActiveCertificatesFoundView: boolean;

  // URL param that is used for automated tests for skipping reCaptcha
  QAkey: string | undefined;

  emerg: boolean;

  @Output() goBackEmit = new EventEmitter<void>();

  // idType: string;     TODO: Remove after some time if there are no problems

  // idTypes: Item[] = [
  //   { name: 'egn', value: 'egn' },   TODO: Remove after some time if there are no problems
  //   { name: 'lnc', value: 'lnc' },
  // ];

  constructor(
    private auth: AuthenticationService,
    public info: InfoService,
    private formBuilder: FormBuilder,
    public progressBarService: ProgressBarService,
    private store: Store<any>,
    private router: Router,
    private emergencyService: EmergencyService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    this.reCaptcha2SiteKey = environment.reCaptcha.reCaptcha2SiteKey;
    this.invisibleCaptchaSiteKey = environment.reCaptcha.invisibleCaptchaSiteKey;
    this.usingLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe(e => this.usingLang = e.lang);
  }

  ngOnInit() {
    // Handling reCaptcha
    this.QAkey = this.activatedRoute.snapshot.queryParams[environment.reCaptcha.automatedTestParamKey];
    const isEmergencyReCaptchaActivated = environment.reCaptcha.emergency;
    this.captchaEnabled = configureReCaptchaWithEnv(isEmergencyReCaptchaActivated, this.QAkey);

    this.emergencyForm = this.formBuilder.group({
      emergencyRequestId: ['', Validators.required],
      recaptcha: this.captchaEnabled ? ['', Validators.required]: []
    });
  }

  // checks for recaptcha response and user input value phone or mail
  onSubmit(emergencyRequestId) {
    this.auth.emergencyLogin(emergencyRequestId, this.recaptchaResponse, this.QAkey)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result: ISpringResponseBody) => {
        if (result.status === 200) {
          this.submit = true;

        } else if (result.status !== 200 && result.code === 'ACTIVE_CERTIFICATES_NOT_FOUND') {
          this.showNoActiveCertificatesFoundView = true;
  
        } else if (result.status !== 200) {
          this.responseResult = result.message;
          this.submit = false;
        }
      });
    this.personalId = emergencyRequestId;
    this.operation.next(OperationTypes.CONFIRM_CODE);
  }

  // if the form was submitted with secret code, pass auth login success and the use was redirected to Certificates directly
  sendSecretCode(code) {
    if (code) {
      code = code.trim();
    }
    this.submit = true;
    this.auth.sendSecretKey(code, this.personalId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result: ISpringResponseBody) => {
        if (result.status === 200) {
          this.secretKeyRes = '';
          this.emergencyService.setEmergencyState();
          this.store.dispatch(new ActionAuthLoginSuccess({ auth: result.data, isEmergencyLogin: true }));
          this.router.navigateByUrl('/certificates');
        } else if (result.status !== 200 && result.code === 'ACTIVE_CERTIFICATES_NOT_FOUND') {
          this.showNoActiveCertificatesFoundView = true;
  
        } else {
          this.secretKeyRes = result.message;
        }
      });
  }

  emergencyLogin(): void {
    this.operation.next(OperationTypes.EMERGENCY_LOGIN);
  }

  goBack(): void {
    this.goBackEmit.emit();
  }

  openNewWindow() {
    this.submit = true;
    this.unsubscribe$.next();
    this.auth.destroySession().subscribe(r => {
      this.submit = false;
      return this.emergencyLogin();
    });
  }

  handleRecaptchaSuccess(result: string) {
    this.recaptchaResponse = result;
  }

  handleRecaptchaLoad() {
    // Nothing is done during captcha load
  }

  handleRecaptchaExpire() {
    // Nothing is done during captcha expire
  }

  getErrorMessage() {
    if (this.emergencyForm.controls.emergencyRequestId.hasError('required')) {
      return this.translateService.instant('validationTexts.requiredField');
    }

    if (this.emergencyForm.controls.emergencyRequestId.hasError('minlength')) {
        return this.translateService.instant('validationTexts.minLengthEmergencyRequestId');
    }
  }
}
